import { getCached } from '@packages/cache/utils'
import storages from '@packages/cache/storages'

import localStorageKeys from '@layers/web/constants/local-storage-keys.ts'

export const useSingleFinder = async () => {
  const userStore = useUserStore()

  const {
    getMemberActiveSingle,
  } = storeToRefs(userStore)

  const { data: singleFinderTempEnable } = await useAsyncData(() => getCached(
    localStorageKeys.singleFinderTempEnable,
    storages.localStorage,
    true
  ), { server: false })

  const isSingleFinderActive = computed(
    () => (
      getMemberActiveSingle.value ||
      singleFinderTempEnable.value
    )
  )

  return {
    isSingleFinderActive,
  }
}
